import { render, staticRenderFns } from "./CreateSubfactor.vue?vue&type=template&id=fc9db30a&scoped=true&"
import script from "./CreateSubfactor.vue?vue&type=script&lang=js&"
export * from "./CreateSubfactor.vue?vue&type=script&lang=js&"
import style0 from "./CreateSubfactor.vue?vue&type=style&index=0&id=fc9db30a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9db30a",
  null
  
)

export default component.exports